import { pageMetadataFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import link from '../link'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  title,
  items[]{
    openingsCount,
    ${link.fragment('ctaLink')},
    location->{
      ${pageMetadataFields},
      phenomCompanyKey
    }
  }
`

export const fragment = (name = 'locations3UpOpenRoles') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
